/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetsMelcoModelsThreadColor
 */
export interface AssetsMelcoModelsThreadColor {
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsThreadColor
     */
    argb?: string | null;
}

export function AssetsMelcoModelsThreadColorFromJSON(json: any): AssetsMelcoModelsThreadColor {
    return AssetsMelcoModelsThreadColorFromJSONTyped(json, false);
}

export function AssetsMelcoModelsThreadColorFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsThreadColor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'argb': !exists(json, 'argb') ? undefined : json['argb'],
    };
}

export function AssetsMelcoModelsThreadColorToJSON(value?: AssetsMelcoModelsThreadColor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'argb': value.argb,
    };
}


